webpackJsonp([32933571477711],{

/***/ 1827:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabTrendInsights","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"analytes","type":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"LabTrendNarrative","ofType":null}}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-lab-trend-insights-05e2273c3d3bdf0b263d.js